import { TransactionType } from "ts/types/Transaction"

import { dialogTitleKeyMap } from "./TransactionDialog.config"

export const getDialogTitleKey = (variant: TransactionType) =>
  dialogTitleKeyMap[variant]
